module.exports = __webpack_public_path__ + "static/media/Gold River CA_02.4eb73d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-db/Gold River CA_02.jpg
// module id = 457
// module chunks = 0